import * as React from "react";
import { useEffect, useState} from "react";
import Box from "@mui/material/Box";
import StyledGrid, { FilterChip } from "../../shared/components/StyledGrid";
import { useNavigate } from "react-router-dom";
import { useAddGroupMutation, useEditGroupMutation, useGetGroupsMutation } from "../../services/InsuranceService";
import useFetchWithMsal from "../../utils/useFetchWithMsal";
import { LoadingPanel } from "../../shared/components/LoadingPanel";
import { Typography, Button, Snackbar, Alert, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { TableFilter } from "../../components/tableFilter/TableFilter";
import { CreateUserPopup } from "./createUserPopup/CreateUserPopup";
import { MultiFieldContainer } from "../tabs/communicationTab/CommunicationTab.styled";
import { Delete, Edit, CheckCircle, Remove } from "@mui/icons-material";
// import { LoadingPanel } from "../../shared/components/LoadingPanel";

const MemberGroupsPage = () => {
  const dispatch = useDispatch();

  const memberGroupsColumns = [
    // {
    //   field: "id",
    //   headerName: "Group Id",
    //   width: 100,
    //   minWidth: 100,
    //   editable: true,
    // },
    {
      field: "groupName",
      headerName: "Group Name",
      width: 300,
      minWidth: 200,
      flex: 1,
      editable: true,
    },
    {
      field: "naic",
      headerName: "NAIC Code",
      width: 100,
      minWidth: 100,
      editable: true,
    },
/*     {
      field: "groupCode",
      headerName: "Group Code",
      width: 100,
      minWidth: 100,
      editable: true,
    }, */
    {
      field: "memberName",
      headerName: "Member Name",
      width: 300,
      minWidth: 200,
      flex: 1,
      editable: true,
    },
    /* {
      field: "assesmentEmail",
      headerName: "Assesment Email",
      width: 300,
      minWidth: 200,
      flex: 1,
      editable: true,
    },
    {
      field: "proxyEmail",
      headerName: "Proxy Email",
      width: 300,
      minWidth: 200,
      flex: 1,
      editable: true,
    }, */
    {
      field: "genericLogin",
      headerName: "Generic Login",
      width: 300,
      minWidth: 200,
      flex: 1,
      editable: true,
    },
    {
      field: "groupAccessCode",
      headerName: "Group Access Code",
      width: 300,
      minWidth: 200,
      flex: 1,
      editable: true,
    },
    {
      field: "active",
      headerName: "Status",
      width: 130,
      editable: true,
      renderCell: (params) => {
        const raw = params?.value; // Expecting 'Yes'/'No'
        const isActive = raw === 'Yes' || raw === true;
        const pillCfg = isActive ? {
          bg: '#dff6dd',
          color: 'success.dark',
          icon: <CheckCircle sx={{ fontSize: 14 }} />,
          label: 'Active'
        } : {
          bg: '#e5e7eb',
          color: 'text.secondary',
          icon: <Remove sx={{ fontSize: 14 }} />,
          label: 'Inactive'
        };
        return (
          <Box component="span" sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.5,
            px: 1,
            py: 0.25,
            borderRadius: '15px',
            fontSize: 12,
            fontWeight: 600,
            bgcolor: pillCfg.bg,
            color: pillCfg.color,
            textTransform: 'capitalize',
            lineHeight: 1,
            minWidth: 70,
            justifyContent: 'center'
          }}>
            {pillCfg.icon}
            {pillCfg.label}
          </Box>
        );
      }
    },
    {
      field: "edit",
      headerName: "",
      width: 30,
      editable: true,
      renderCell: (params) => (
        <MultiFieldContainer>
          <Edit
            style={{ cursor: params?.row?.groupId && "pointer", color: params?.row?.groupId ? "#003366" : 'gray' }}
            onClick={() => params?.row?.groupId && onEditClick(params)}
          />
        </MultiFieldContainer>
      ),
    },
    // {
    //   field: "delete",
    //   headerName: "",
    //   width: 30,
    //   editable: true,
    //   renderCell: (params) => (
    //     <MultiFieldContainer>
    //       <Delete
    //         style={{ cursor: "pointer", color: "#990000" }}
    //       />
    //     </MultiFieldContainer>
    //   ),
    // }
  ];

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 50,
  });
  const [totalCount, setTotalCount] = useState(0);
  const [showAddGroupPopup, setShowAddGroupPopup] = useState(false);
  const [rowData, setRowData] = useState(null);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [alertMessage, setAlertMessage] = useState(null);

  const [dublicatedMembers, setDublicatedMembers] = useState(null);

  const onPopupClose = () => {
    setShowAddGroupPopup(false);
    setRowData(null);
  };

  const [sortingModel, setSortingModel] = useState();
  const { skip } = useFetchWithMsal();

  const [getGroups, { data, isLoading }] = useGetGroupsMutation("", { skip });
  const [addGroup, {isLoading: isAddGroupLoading}] = useAddGroupMutation("", { skip });
  const [editGroup, {isLoading: isEditGroupLoading}] = useEditGroupMutation("", { skip });

  const handleGroups = async (values) => {
    try {
      let response;
      response = values?.id ? await editGroup(values) : await addGroup(values);
      if (response?.error) {
        throw new Error(response.error.data?.Message || "Unknown error occurred");
      }
      setAlertMessage(response?.data?.message);
      setSnackbarSeverity(response?.data?.status);
      setDublicatedMembers(response?.data?.members)
  
      if (response?.data?.status === "need-confirm") {
        setPendingValues(values);
        setConfirmDialogOpen(true);
      } else {
        setSnackbarOpen(true);
      }
      if (response?.data?.status === "success") {
        onPopupClose()
      }
      
    } catch (error) {
      setAlertMessage(error.message);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };
  
  const handleConfirmationDialogClose = (confirmed) => {
    setConfirmDialogOpen(false);
    if (confirmed && pendingValues) {
      handleGroups({ ...pendingValues, isConfirm: true }); // Отправляем те же данные + isConfirm
      setPendingValues(null);
    }
  };
  
  // Добавляем состояние для хранения данных перед повторной отправкой
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [pendingValues, setPendingValues] = useState(null);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const navigate = useNavigate();
  const { naicCode, memberName, email, groupName } = useSelector(
    (state) => state.filter
  );

  useEffect(() => {
    if(!skip && !isAddGroupLoading && !isEditGroupLoading){
      fetchData()
    }
  }, [
    paginationModel.page,
    paginationModel.pageSize,
    sortingModel?.field,
    sortingModel?.sort,
    isAddGroupLoading,
    isEditGroupLoading,
    skip
  ]);

  useEffect(() => {
    if (!isLoading) {
      if (data?.totalCount !== totalCount) {
        setTotalCount(data?.totalCount);
      }
    }
  }, [isLoading]);

  useEffect(() => {
    if (!isLoading) {
      if (data?.totalCount !== totalCount) {
        setTotalCount(data?.totalCount);
      }
    }
  }, [isLoading]);

  const fetchData = (value) => {
    const body = {
      page: paginationModel.page + 1,
      pageSize: paginationModel.pageSize,
      orderBy: sortingModel?.field || "",
      orderByDirection: sortingModel?.sort || "",
      naicCode: value? value.naicCode : naicCode,
      memberName: value? value.memberName : memberName,
      email: value? value.email : email,
      groupName: value? value.groupName : groupName,
      groupId: true
    };
    getGroups(body);
  };
  
  const handlePaginationModelChange = (newPaginationModel) => {
    setPaginationModel(newPaginationModel);
  };

  const onApplyFilters = (value) => {
    if(paginationModel.page){
      setPaginationModel(prev => { return {...prev, page:0}})

    } else {
      !skip && fetchData(value)
    }
  };

  const onEditClick =(e)=>{
    setRowData(e.row)
    setShowAddGroupPopup(!showAddGroupPopup)
  }

  const formattedData = data?.items?.map((row) => ({
    ...row,
    id: row.naic, 
    
  }));
 
  return (
    <Box sx={{ height: "100%", width: "100%", margin: "50px auto 0 auto" }}>
      {isLoading || isAddGroupLoading || isEditGroupLoading && <LoadingPanel />}
      <Box display={"flex"} sx={{ justifyContent: "space-between" }} mb={3}>
        <Typography variant="h1" color="primary.main" sx={{ marginLeft: "16px" }}>
          Group Management
        </Typography>
        <Box display={"flex"}>
        <TableFilter onApplyFilters={onApplyFilters} type="groups"/>
        <Button onClick={() => setShowAddGroupPopup(!showAddGroupPopup)} variant="outlined">
          Add Group
        </Button>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          gap: 1,
          flexWrap: "wrap",
          alignItems: "center",
          marginRight: "15px",
          marginBottom: "15px",
        }}
      >
        {naicCode && <FilterChip>NAIC Code: {naicCode}</FilterChip>}
        {groupName && <FilterChip>Group Name: {groupName}</FilterChip>}
        {memberName && <FilterChip>Member Name: {memberName}</FilterChip>}
        {email && <FilterChip>Email: {email}</FilterChip>}
      </Box>
      <StyledGrid
        data={formattedData}
        // getRowId={() => Math.floor(Math.random() * 100000000)}
        width="100%"
        columns={memberGroupsColumns}
        rowCount={totalCount}
        withFilter
        onSortingModelChange={(model) => setSortingModel(model[0])}
        paginationModel={paginationModel}
        setPaginationModel={handlePaginationModelChange}
        // withMenu
      />
      <CreateUserPopup
        open={showAddGroupPopup}
        onClose={onPopupClose}
        data={rowData}
        addGroup={handleGroups}
        editGroup={handleGroups}
      />
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {alertMessage}
        </Alert>
      </Snackbar>
      <Dialog
        open={confirmDialogOpen}
        onClose={() => handleConfirmationDialogClose(false)}
      >
        <DialogTitle>Warning</DialogTitle>
        <DialogContent>
          <Typography>
          The following members are linked to another group:
          {dublicatedMembers?.map((member, index) => (
            <Typography key={index}>
              - <b>{member.memberName}</b>
            </Typography>
          ))}
          Selected members will be linked to a new group.</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleConfirmationDialogClose(false)} color="primary">
            CANCEL
          </Button>
          <Button onClick={() => handleConfirmationDialogClose(true)} color="primary">
            PROCEED
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default MemberGroupsPage;
